import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function EkonomikaPreduzeca() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Ekonomika preduzeca" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Ekonomika preduzeca</h2>
              <p>
                <strong>Studijski program:</strong> Računovodstvo finansije i
                bankarstvo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Ekonomika preduzeca
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Osnovni cilj Poslovne ekonomike je da studentima kroz teorijsku
                i praktičnu nastavu predstavi suštinu i karakter savremenog
                poslovanja preduzeća razvijajući kod studenata shvatanje suštine
                efikasnosti poslovanja preduzeća i donošenja optimalnih
                poslovnih odluka u pravcu ostvarenja maksimalnih rezultata uz
                što niža ulaganja sredstava. Pri tome se studenti upoznavaju sa
                ekonomskim zakonitostima koje utiču na efikasnost poslovanja
                preduzeća i stiču potrebna znanja za: upravljanje ulaganjima
                sredstava, upravljanje troškovima, upravljanje poslovnim
                rezultatima, mjerenje, ocjenjivanje i podizanje efikasnosti
                poslovanja, kao i usmjeravanje razvoja preduzeća.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Na kraju savladavanja sadržaja predmeta, studenti su
                osposobljeni da shvate preduzeće kao subjekt tržišnog
                privređivanja, zakonitosti upravljanja ulaganjima, zakonitosti
                upravljanja troškovima, način izražavanja i mjerenja efikasnosti
                poslovanja preduzeća, zakonitosti podizanja efikasnosti
                poslovanja, kao i značaj troškovne konkurentnosti u ostvarivanju
                razvoja preduzeća. Studenti posjeduju potrebna znanja za
                formiranje određenih profila stručnosti, primjenljivost znanja u
                poslovnoj praksi, konkretne oblasti, aktuelnost
                teorijsko-metodološkog i praktično-aplikativnog znanja iz ove
                oblasti, kao i povezivanje nastavnog sadržaja konkretnog
                predmeta sa nastavnim sadržajem međusobno uslovljenih ekonomskih
                naučnih disciplina.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava: Cilj predmet i metode poslovne ekonomike;
                Preduzeće kao subjekt tržišnog privređivanja; Angažovanje
                sredstava preduzeća i pojavni oblici; Osnovna i obrtna sredstva
                amortizacija osnovnih sredstava i optimizacija proizvodnje;
                Metode optimizacije obrtnih sredstava vanposlovna sredstva i
                izvori sredstava preduzeća; Troškovi vrste troškova i faktori
                visine troškova; Klasifikacija troškova po reagovanju na
                promjenu obima proizvodnje i po načinu uračunavanja u cijenu
                koštanja; Ukupni troškovi zone dinamike remanentnost granični
                troškovi troškovi i prihodi; Kalkulacije cijene koštanja
                principi vrste i metode; Diviziona dodatna kalkulacija i Direct
                Costing; Pojavni oblici rezultata preduzeća i raspodjela;
                Efikasnost poslovanja preduzeća i problemi izražavanja;
                Ekonomski i finansijski pokazatelji efikasnosti poslovanja; Cilj
                faze i faktori razvoja preduzeća; Usmjeravanje razvoja preduzeća
                razvojna politika strategija razvoja i investicije. Praktična
                nastava prati teorijsku nastavu uključujući brojne primjere iz
                prakse.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja nakon kojih se studentima ostavlja vrijeme za
                diskusiju i objašnjenja i vježbe sa aktivnim učestvovanjem
                studenata na analizi slučajeva iz prakse uz vježbanje
                kvantitativne metodologije na slučajevima iz prakse. Program se
                zasniva na interaktivnom pristupu izučavanju pri čemu se
                studenti aktiviraju na učešće u savladavanju teorije i
                metodologije konkretnog predmeta u pravcu istraživanja
                teorijskih zakonitosti i metodoloških rješenja podizanja
                efikasnosti poslovanja.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 2V</td>
                    <td>
                      Cilj predmet i metode poslovne ekonomike; Preduzeće kao
                      subjekt tržišnog privređivanja
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 2V</td>
                    <td>
                      Angažovanje sredstava preduzeća i pojavni oblici; Osnovna
                      i obrtna sredstva amortizacija osnovnih sredstava i
                      optimizacija proizvodnje
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 2V</td>
                    <td>
                      Metode optimizacije obrtnih sredstava vanposlovna sredstva
                      i izvori sredstava preduzeća; Troškovi vrste troškova i
                      faktori visine troškova
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 2V</td>
                    <td>Troškovi vrste troškova i faktori visine troškova</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 2V</td>
                    <td>
                      Klasifikacija troškova po reagovanju na promjenu obima
                      proizvodnje i po načinu uračunavanja u cijenu koštanja
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 2V</td>
                    <td>
                      Ukupni troškovi zone dinamike remanentnost granični
                      troškovi troškovi i prihodi
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 2V</td>
                    <td>Kalkulacije cijene koštanja principi vrste i metode</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 2V</td>
                    <td>Diviziona dodatna kalkulacija i Direct Costing</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 2V</td>
                    <td>Pojavni oblici rezultata preduzeća i raspodjela</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 2V</td>
                    <td>
                      Efikasnost poslovanja preduzeća i problemi izražavanja
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Ekonomski i finansijski pokazatelji efikasnosti poslovanja
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 2V</td>
                    <td>Cilj faze i faktori razvoja preduzeća</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 2V</td>
                    <td>
                      Usmjeravanje razvoja preduzeća razvojna politika
                      strategija razvoja i investicije
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 4,30 h</td>
                            <td>Ukupno: 120 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 3,00 h</td>
                            <td>Nastava + završni ispit: 90 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1,30 h</td>
                            <td>Priprema i ovjera semestra: 9 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 21 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default EkonomikaPreduzeca;
